import { HttpService } from './http-base.service';

export default class GeminiService extends HttpService {
  constructor(baseURL) {
    if (!GeminiService.instance) {
      super(baseURL);
      GeminiService.instance = this;
    }

    return GeminiService.instance;
  }

  generateSummary(requestData) {
    const data = {
      placeName: requestData.placeName,
      placeAddress: requestData.placeAddress,
      reviews: requestData.reviews,
    };

    console.log('Gemini Service - Sending request data:', data);

    return this.post('/api/gemini/generate-summary', data)
      .then((response) => {
        console.log('Gemini Service - Received response:', response);
        return response;
      })
      .catch((err) => {
        console.error('Gemini Service - Request failed:', err);
        throw err;
      });
  }
}
